module.exports = __webpack_public_path__ + "img/com.ifisek.instareportapp-staging.463a8977.png";